import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ShopHeader from "@/components/layout/ShopHeader";
import ShopFooter from "@/components/layout/ShopFooter";
import SlimFooter from "@/components/layout/SlimFooter";
import CartDrawer from "@/components/CartDrawer";
import DemoBar from "@/components/product/DemoBar";
import { useMall } from "@/context/MallContext";
import { useSettings } from "@/context/SettingsContext";
import { ruleFor } from "@/siteMap";

/**
 * Phase 10 — ONE storefront for every shop: the two-row header (shop row + black menu row), the page,
 * the full footer. `designer` pages fill the screen and end in the one-line footer instead.
 */
export default function Layout({ children, designer, title }) {
    const { pathname } = useLocation();
    const { shown: store } = useMall();
    const settings = useSettings();
    const shopName = store?.name || settings?.business?.short_name || "13thav";
    const pageTitle = title || ruleFor(pathname)?.title;

    useEffect(() => { document.title = `${pageTitle || "Order"} | ${shopName}`; }, [pageTitle, shopName]);

    return (
        <div className="App relative flex min-h-screen flex-col bg-white text-zinc-900" data-testid="site-shell">
            <DemoBar />
            <ShopHeader />
            <main className="relative z-[2] flex-1">{children}</main>
            {designer ? <SlimFooter /> : <ShopFooter />}
            <CartDrawer />
        </div>
    );
}
